import React from 'react'

import { css } from 'design'
import { Stack } from 'primitives/containers'
import { cn } from 'util/cn'

export const UpgradePromptButton = ({ children, ...props }: any) => {
  return (
    <Stack
      as={'button'}
      gap={1}
      {...props}
      className={cn(buttonStyles(), props.className)}
    >
      {children}
    </Stack>
  )
}

const buttonStyles = css({
  position: 'relative',
  zIndex: 1,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  outlineOffset: '1px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  textAlign: 'left',

  '&:before': {
    content: '',
    inset: 0,
    background:
      'radial-gradient(circle at 100% 95%, #03f2c2, #4f8bff 34%, #f60575 65%, #ff672c 81%, #ffb207 97%, #ffb600 103%)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: -1,
    borderRadius: '10px',
  },

  '&:after': {
    content: '',
    position: 'absolute',
    inset: '1px',
    zIndex: -1,
    background: '$grey50',
    borderRadius: '9px',
  },
})
